import React from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import useFormat from 'modules/react/loan-calculator/hooks/useFormat'

export default function CarHeader () {
  const { carInfo } = React.useContext(LoanCalculatorContext)
  const { name, tagline, price } = carInfo
  const { formatPrice } = useFormat()

  return (
    <div className={'lc-car-header'}>
      <div className={'lc-car-header__left'}>
        <h2 className={'lc-car-header__name'}>{name}</h2>
        <span className={'lc-car-header__name-tagline'}>{tagline}</span>
      </div>
      <div className={'lc-car-header__right'}>
        <p className={'lc-car-header__price'}>{formatPrice(price)}</p>
        <span className={'lc-car-header__price-tagline'}>Bilens pris</span>
      </div>
    </div>
  )
}
